/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="membershipManager.module.ts" />
///<reference path="../../components/common/businessInfo.service.ts"/>


module Meevo.Plugins.MembershipManager {
    import ClientMembershipIndicatorEnum = Meevo.Model.ClientMembershipIndicatorEnum;
    import ClientMembershipIndicatorStatusEnum = Meevo.Model.ClientMembershipIndicatorStatusEnum;
    import ClientMembershipSearchStatusEnum = Meevo.Model.ClientMembershipSearchStatusEnum;
    import IClientMembershipIndicator = Meevo.Components.Common.IClientMembershipIndicator;
    import FreezeSettingEnum = Meevo.Model.FreezeSettingEnum;

    class MembershipManagerController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public searchContextCriteria: any = {};
        public coColumnsSet = [
            { header: "Membership Status", fieldName: 'MembershipStatus', sortDirection: null, width: 40 },
            { header: "Home Location", fieldName: 'HomeLocation', sortDirection: null, width: 60 }
        ];
        public displayNameColumn = { header: "Name", fieldName: 'Name', sortDirection: Model.SortDirection.Ascending, width: 40 };
        public filterOptions: any;
        public searchRetrievalCallback: Function;
        public membershipNumber: string;
        public clientMembershipIndicatorEnum = ClientMembershipIndicatorEnum;
        public clientMembershipIndicatorStatusEnum = ClientMembershipIndicatorStatusEnum;
        public filterMembershipStatus: any = null;
        public filterSelectedFrozen: boolean = false;
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;
        private _freezeSettingList = {
            [FreezeSettingEnum.AccruedServiceOnly]: 'LABEL_ACCRUED_SERVICES_ONLY',
            [FreezeSettingEnum.FullAccess]: 'LABEL_FULL_ACCESS?',
            [FreezeSettingEnum.MemberBenefitsOnly]: 'LABEL_MEMBER_BENEFITS_ONLY',
            [FreezeSettingEnum.NoAccess]: 'LABEL_NO_ACCESS',
        };

        private _clientMembership;

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.ClientMembershipDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "meevo.components.common.BusinessInfoDataService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "$mdDialog",
            "meevo.components.busy.BusyService",
            "$translate",
            "$q",
            "$timeout",
            "$locale",
            "$filter",
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.Common.ClientMembershipDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected $mdDialog: angular.material.IDialogService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: ng.IQService,
                    protected $timeout: ng.ITimeoutService,
                    protected $locale: angular.ILocaleService,
                    protected $filter: angular.IFilterService,
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.filterOptions = {
                coFilterByLocationId: [
                    {
                        id: identityService.inCentralOfficeMode() ? null : identityService.locationId,
                        displayName: 'Local Members Only'
                    },
                    {
                        id: null,
                        displayName: 'Global - All Members'
                    }
                ],
                membershipStatus: [
                    {
                        id: null,
                        displayName: "LABEL_ALL"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.AllMembers,
                        displayName: "LABEL_ALL_MEMBERS"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.Active,
                        displayName: "LABEL_ACTIVE"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.Initial90,
                        displayName: "LABEL_INITIAL_90"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.WithinInitialTerm,
                        displayName: "LABEL_WITHIN_INITIAL_TERM"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.InRenewalTerm,
                        displayName: "LABEL_IN_RENEWAL_TERM"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.Expired,
                        displayName: "LABEL_EXPIRED"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.InCancellation,
                        displayName: "LABEL_IN_CANCELLATION"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.CCAboutToExpire,
                        displayName: "LABEL_CC_ABOUT_TO_EXPIRE"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.Grandfathered,
                        displayName: "LABEL_GRANDFATHERED"
                    },
                    {
                        id: ClientMembershipIndicatorStatusEnum.Frozen,
                        displayName: "LABEL_FROZEN"
                    },
                    {
                        id: ClientMembershipIndicatorStatusEnum.Suspended,
                        displayName: "LABEL_SUSPENDED"
                    },
                    {
                        id: ClientMembershipSearchStatusEnum.MembershipAboutToExpire,
                        displayName: "LABEL_MEMBERSHIP_ABOUT_TO_EXPIRE"
                    }
                ],
                COId: identityService.current().centralOfficeId
            };

            businessInfoDataService
                .getBusinessInfoPreferences()
                .then(settings => {
                    if (settings.clientsSettings.localClientSearchOnly) {
                        this.filterOptions.coFilterByLocationId = this.filterOptions.coFilterByLocationId.slice(0, 1);
                    }
                });

            $scope.$on(Meevo.Components.Common.Messages.CLOSE_CONTEXT_WARNING, (event, state, params) => {
                if (state.name !== this.appSettings.ROUTE_NAMES.membershipManager) {
                    return;
                }

                this.beforeClose()
                    .then(() => {
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, state);
                    });
            });

            $scope.$on(Meevo.Components.Common.Messages.HIDE_MODAL_WINDOW, () => {
                this.$mdDialog.hide();
            });

            $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
                if (toState.name === 'membershipManager' && toState.params.refresh) {
                    toState.params.refresh = false;

                    const membershipContext = this.context as MembershipManagerContext;
                    if (membershipContext) {
                        membershipContext.updateMembershipIndicator().then(() => {
                            membershipContext.reloadSelectedSection();
                        });
                    }
                }
            });

            /**
             * Callback for retrieve Clients Membership Indicators
             * function in constructor because need use this.dataService function
             * */
            this.searchRetrievalCallback = (pageNumber, pageList: Array<Meevo.Model.ClientMembership>, context): void => {
                let clientIds = <Guid[]>pageList.map(item => item.clientId);
                this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/settings/transworldFields/`, 'GET', null)
                    .then(res => {
                        if (pageList && pageList.length && res.data.enableTransworld) {
                            return this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/Transworld/Client/List/`, 'POST', { clients: clientIds });
                        }

                        return this.$q.reject();
                    }).then(res => {
                        const formatedClientsList: any = _.indexBy(res.data, 'clientId');
                        pageList.forEach((client: Meevo.Model.ClientMembership) => {
                            client.isSentToTransworld = formatedClientsList[<string>client.clientId].isSentToTransworld;
                        });
                    });
            }

            if ((this.selectedItemId != undefined || (this.contextParams.params && this.contextParams.params.membershipNumber)) &&
              this.context == undefined) {
                this.createContext();
            }
        }

        // When plugin is activated (Update data when comeback)
        onRouteActive() {
            super.onRouteInactive();

            if (this.$state.current.name == "membershipManager" && !this.showSearch) {
                if (this.context && this.context.selectedSection && (this.context.selectedSection.sectionId === 2 || this.context.selectedSection.sectionId === 3)) {
                    // func from base section in plugin
                    this.context.selectedSection['loadDependentData']();
                }
            }
        }

        /**
         * Get translate for enum
         * */
        clientMembershipIndicatorEnumIcon(num): string {
            return this.dataService.getClientMembershipIndicatorEnumIcon(num);
        };

        clientMembershipIndicatorStatusText(num): string {
            return this.dataService.getClientMembershipIndicatorStatusEnumText(num);
        };

        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MEMBERSHIP_MEMBERSHIPMANAGER).then(() => {
              if (this.contextParams.params && this.contextParams.params.membershipNumber) {
                this.membershipNumber = this.contextParams.params.membershipNumber;
                this.dataService.getListPaged("/Membership/Client",
                  { pageNumber: 0, itemsPerPage: 20, criteria: { membershipNumber: this.membershipNumber } })
                  .then((data: any) => {
                    if (data.length > 0) {
                      this.busyService.stop();
                      this._clientMembership = data[0];
                      this.selectedItemId = this._clientMembership.id;
                      this.visualState = Meevo.Model.MaintenanceFormVisualState.Detail;
                      this.createContextWorker();
                    } else {
                      this.createMembershipContext();
                    }
                  });
              } else {
                this.createMembershipContext();
              }
            }).catch(() => {
                this.busyService.stop();
            });
        }

        createMembershipContext(): void {
          this._clientMembership = <IMembershipManagerSearchContext>_.findWhere(this.searchContext, { 'id': this.selectedItemId });
          if (!this._clientMembership && this.selectedItemId != undefined) {
            this.busyService.stop();
            this.dataService.getListPaged("/Membership/Client",
              { pageNumber: 0, itemsPerPage: 20, criteria: { clientMembershipId: this.selectedItemId } })
              .then((data: any) => {
                this._clientMembership = data[0];
                this.createContextWorker();
              });
          } else {
            this.busyService.stop();
            this.createContextWorker();
          }
        }

        createContextWorker() {
            this.context = new MembershipManagerContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$rootScope, this.$translate, this.$q, this.$timeout, this.$locale, this._clientMembership, this.$filter, this.$scope);
            this.context.activate(this.selectedItemId, this.initialEditSection, this.asLocationId);
            this.context.deactivate = () => {
                this.visualState = Model.MaintenanceFormVisualState.Search;
            };
        }
        /**
         * Prompt user when unsaved changes have been made prior to exiting or closing screen
         * */
        beforeClose(): ng.IPromise<any> {
            let deferred = this.$q.defer();

            if (this.visualState === Model.MaintenanceFormVisualState.Detail && this.context['mode'] === Model.MaintenanceFormState.Editing) {
                this.modalService.confirmHandler('MESSAGE_MEMBERSHIPMANAGER_CLOSE_UNSAVED', Meevo.Components.Modal.ModalTranslationModes.Translate)
                    .then((response: boolean) => {
                        if (response) {
                            this.context['clientMembership'] = undefined;
                            deferred.resolve();                            
                        } else {
                            deferred.reject();
                        }
                    });
            } else {
                if (this.visualState === Model.MaintenanceFormVisualState.Detail) {
                    this.context['clientMembership'] = undefined;
                }
                deferred.resolve();
            }

            return deferred.promise;
        }

        clearAdvancedSearch(clearAdvancedSearchFn: Function, isApplicationModeCO: boolean): void {
            this.searchContextCriteria.location = !isApplicationModeCO ? this.filterOptions.coFilterByLocationId[0] : undefined;
            clearAdvancedSearchFn();
        }
    }

    angular.module("meevo.plugins.membershipManager")
        .controller("meevo.plugins.membershipManager.membershipManagerController", MembershipManagerController);
}
